<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center flex-wrap">
      <h4 class="mb-0 font-size-18 me-4">
        <app-back-button [backRouterLink]="backRouterLink"></app-back-button>
        {{ title }}
      </h4>
      <div>
        <app-breadcrumbs [breadcrumbItems]="breadcrumbItems$ | async"></app-breadcrumbs>
      </div>
    </div>
  </div>
</div>